// import Gleap from 'gleap';
var LiveChatService = /** @class */ (function () {
    function LiveChatService(AccountsService, $window, angularLoad, Users, $q, LIVE_CHAT_LICENSE, Accounts) {
        this.AccountsService = AccountsService;
        this.$window = $window;
        this.angularLoad = angularLoad;
        this.Users = Users;
        this.$q = $q;
        this.Accounts = Accounts;
        // this.$window.__lc = {};
        // this.$window.__lc.license = LIVE_CHAT_LICENSE;
        // this.$window.__lc.params = [];
        // this.liveChatPatch = "/assets/js/liveChat.js";
    }
    LiveChatService.prototype.initUserInfo = function (user) {
        if (window['Gleap']) {
            window['Gleap'].identify(user.username, {
                name: user.name,
                email: user.username,
                companyId: this.AccountsService.current(),
                companyName: this.AccountsService.currentAccountName(),
            });
            this.Accounts.plan().$promise.then(function (res) {
                window['Gleap'].updateContact({
                    plan: res.planName,
                    customData: {
                        usersLimit: res.usersLimit,
                    },
                });
            });
        }
        else {
            console.warn('Gleap not initialized');
        }
        // this.$window.__lc.visitor = {
        //   name: user.name,
        //   email: user.username
        // };
        // this.$window.__lc.params.push({name: 'Domain', value: window.location.hostname});
        // this.$window.__lc.params.push({name: 'AccountName', value: this.AccountsService.currentAccountName()});
        // this.Accounts.plan().$promise.then(res => {
        //   this.$window.__lc.params.push({name: 'Plan', value: res.planName});
        //   this.$window.__lc.params.push({name: 'Users limit', value: res.usersLimit})
        // }).finally(() => {
        //   if (!this.isLocalhost()) this.angularLoad.loadScript(this.liveChatPatch);
        //   if (this.isLiveChatIframe()) this.hideLiveChatWidget();
        // });
    };
    LiveChatService.prototype.initLiveChatWithoutAuth = function () {
        if (window['Gleap']) {
            window['Gleap'].identify(undefined, {
                companyId: this.AccountsService.current(),
                companyName: this.AccountsService.currentAccountName(),
            });
        }
        // this.$window.__lc.params.push({name: 'Domain', value: window.location.hostname});
        // this.$window.__lc.params.push({name: 'AccountName', value: this.AccountsService.currentAccountName()});
        // if (!this.isLocalhost() && !this.isLiveChatIframe()) this.angularLoad.loadScript(this.liveChatPatch);
    };
    LiveChatService.prototype.contactSupport = function () {
        if (window['Gleap']) {
            window['Gleap'].open();
        }
        else {
            console.warn('Gleap not initialized');
        }
        // try {
        //   if (this.isLiveChatHidden()) {
        //     this.openLiveChatDirectly();
        //     return;
        //   }
        //   this.$window.LC_API.open_chat_window();
        // } catch (e) {
        //   Raven.captureException(e);
        //   this.openLiveChatDirectly();
        // }
    };
    LiveChatService.prototype.openLiveChatDirectly = function () {
        // this.$window.location.assign("https://secure.livechatinc.com/licence/6849311/v2/open_chat.cgi?groups=4");
    };
    LiveChatService.prototype.isLiveChatHidden = function () {
        // const liveChatContainer = this.$window.document.getElementById("chat-widget");
        // const style = this.$window.getComputedStyle(liveChatContainer);
        // return style.display === 'none' || style.visibility === 'hidden' || parseInt(style.zIndex, 10) <= 10;
    };
    LiveChatService.prototype.isLocalhost = function () {
        // return this.$window.location.hostname === 'localhost';
    };
    LiveChatService.prototype.isLiveChatIframe = function () {
        // try {
        //   return this.$window.self !== this.$window.top;
        // } catch (e) {
        //   return true;
        // }
    };
    LiveChatService.prototype.hideLiveChatWidget = function () {
        // this.$window.LC_API.on_after_load = () => {
        //   const chatWidget = this.$window.document.getElementById("chat-widget-container");
        //   if (chatWidget) {
        //     chatWidget.style.visibility = "hidden";
        //   }
        // }
    };
    LiveChatService.$inject = ['AccountsService', '$window', 'angularLoad', 'Users', '$q', 'LIVE_CHAT_LICENSE', 'Accounts'];
    return LiveChatService;
}());
export default LiveChatService;
//# sourceMappingURL=live.chat.service.js.map